<template>
  <layout-general v-if="modalVisible === 'report-export-in-progress'" @close="modalClose()">
    <h4 class="modal-title" slot="header">{{ $t('general.labels.exporting') }}...</h4>
    <div slot="body">
      <div>
        <h4 class="help-block">{{ $t('general.labels.your') }}
        <span class="important-info">{{ $t('modal.export_table_in_progress.processing_request') }}</span>
         {{ $t('modal.export_table_in_progress.send_email') }}
        <span class="important-info">{{email}}</span>. {{ $t('modal.export_table_in_progress.some_hours') }}</h4>
      </div>
    </div>

    <div slot="footer">
      <button class="btn btn-default" @click="modalClose()">{{ $t('general.actions.close') }}</button>
    </div>
  </layout-general>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LayoutGeneral from './layout/General.vue';

export default {
  props: [
    'email',
  ],
  components: {
    LayoutGeneral,
  },
  computed: mapGetters({
    modalVisible: 'modalVisible',
  }),
  methods: mapActions([
    'modalClose',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** ExportTableInProgress.vue?21d79b98
 **/